import { createFileRoute } from '@tanstack/react-router';

import {
  CustomerOrdersPage,
  validateCustomerOrdersSearch,
} from '../../features/customer-orders';

export const Route = createFileRoute('/_app/orders')({
  staticData: { crumbs: ['Заказы 1С'] },
  validateSearch: validateCustomerOrdersSearch,
  component: CustomerOrdersPage,
});
